import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import LookupForm from './lookupForm'
import { stringifyQuery } from '../../helpers/queryHelper'
import { displayNotification } from '../../actions/notificationsActions'

export type Callback<T = void> = (...args: any) => T

export const goToIndex = (paramsObj, indexPath, history) => {
  const withDefaults = Object.assign({}, paramsObj, {
    offset: 0,
    limit: 25,
  })

  history.push({
    pathname: indexPath,
    search: stringifyQuery(withDefaults),
  })
}

export const lookupUsers = (value, history, notification) => {
  if (value.includes('@')) {
    // when input is an email
    goToIndex({ email: value }, '/users', history)
  } else if (value.includes('#')) {
    // when input is an id
    history.push({
      pathname: `/users/${value.replace('#', '')}`,
    })
  } else if (!/[^\d-\(\) ]/.test(value) && value.length >= 9) {
    // when input is a phone
    goToIndex({ phone: value.replace(/\D/g, '') }, '/users', history)
  } else if (!/[^a-z ]/i.test(value)) {
    // when input is a name
    goToIndex({ name: value }, '/users', history)
  } else {
    notification(`Unable to lookup users with ${value}`, 'error', 2000)
  }
}

export const lookupAdmins = (value, history, notification) => {
  if (value.includes('@')) {
    // when input is an email
    goToIndex({ email: value }, '/admins', history)
  } else if (value.includes('#')) {
    // when input is an id
    history.push({
      pathname: `/admins/${value.replace('#', '')}`,
    })
  } else if (!/[^a-z ]/i.test(value)) {
    // when input is a name
    goToIndex({ name: value }, '/admins', history)
  } else {
    notification(`Unable to lookup admins with ${value}`, 'error', 2000)
  }
}

export const lookupProducts = (value, history, notification) => {
  if (value.includes('@')) {
    // when input is an email
    goToIndex({ email: value }, '/products', history)
  } else if (value.includes('#')) {
    // when input is a user id. Intentional: product packages have no page of
    // their own, so '#id' jumps to that customer's profile (same as users).
    history.push({
      pathname: `/users/${value.replace('#', '')}`,
    })
  } else if (!/[^\d-\(\) ]/.test(value) && value.length >= 9) {
    // when input is a phone
    goToIndex({ phone: value.replace(/\D/g, '') }, '/products', history)
  } else if (!/[^a-z ]/i.test(value)) {
    // when input is a name
    goToIndex({ name: value }, '/products', history)
  } else {
    notification(`Unable to lookup products with ${value}`, 'error', 2000)
  }
}

export const lookupOrganizations = (value, history, notification) => {
  if (value.includes('#')) {
    // when input is an id
    history.push({
      pathname: `/organizations/${value.replace('#', '')}`,
    })
  } else if (value.trim()) {
    // when input is a name
    history.push({
      pathname: '/organizations',
      search: stringifyQuery({ name: value.trim() }),
    })
  } else {
    notification(`Unable to lookup organizations with ${value}`, 'error', 2000)
  }
}

export const lookupLoans = (value, history, notification) => {
  if (!/[^\d-\(\)]/.test(value)) {
    // when input is an id
    const id = value.replace('#', '')
    goToIndex({ loanId: id }, '/refinance', history)
  } else {
    notification(`Unable to lookup loans with ${value}`, 'error', 2000)
  }
}

export const lookupVehicles = (value, history, notification) => {
  if (/[^\d]/.test(value) && /[^a-z]/i.test(value)) {
    // when input is an a vin
    goToIndex({ vin: value }, '/vehicles', history)
  } else {
    notification(`Unable to lookup vehicles with ${value}`, 'error', 2000)
  }
}

export const lookupFunc = (values, history, notification) => {
  const { findInput, findSelect } = values
  switch (findSelect) {
    case 'users':
      return lookupUsers(findInput, history, notification)
    case 'loans':
      return lookupLoans(findInput, history, notification)
    case 'vehicles':
      return lookupVehicles(findInput, history, notification)
    default:
      notification('Please select an option', 'error', 2000)
  }
}

export interface Props {
  history: History
  location: Location
  displayNotification: Callback
}

export class Lookup extends Component<Props> {
  static displayName = 'Lookup'

  onSubmit = (values) => {
    const { history, location, displayNotification } = this.props
    const { findInput } = values
    const { pathname } = location
    if (pathname.startsWith('/admins')) {
      lookupAdmins(findInput, history, displayNotification)
    } else if (pathname.startsWith('/users')) {
      lookupUsers(findInput, history, displayNotification)
    } else if (pathname.startsWith('/products')) {
      lookupProducts(findInput, history, displayNotification)
    } else if (pathname.startsWith('/organizations')) {
      lookupOrganizations(findInput, history, displayNotification)
    } else {
      lookupFunc(values, history, displayNotification)
    }
  }

  render() {
    return (
      <div className="lookup header__item--right">
        <LookupForm
          onSubmit={this.onSubmit}
          initialValues={{ findSelect: 'loans' }}
        />
      </div>
    )
  }
}

export default withRouter(connect(null, { displayNotification })(Lookup))
